//
import Service from '@/services/api/service'
import PchDetailPurchaseOrderModel from '@/models/Purchase/PchDetailPurchaseOrder'

/**
 * This class describes a pch detail purchase order.
 *
 * @class      PchDetailPurchaseOrder (name)
 */
export default class PchDetailPurchaseOrder extends Service {

  /**
   * The pch detail purchase order headers
   *
   * @return     {Array}  headers definitions
   */
  static headers() {
    return [
      {
        text: 'código interno',
        value: 'wh_internal_code',
      },
      {
        text: 'código proveedor',
        value: 'provider_product_code',
      },
      {
        text: 'nombre',
        value: 'wh_product_name',
      },
      {
        text: 'descripción',
        value: 'wh_description',
      },
      {
        text: 'estado',
        value: 'status',
      },
      {
        text: 'cantidad',
        value: 'quantity',
      },
      {
        text: 'valor unitario',
        value: 'net_price',
        format: 'currency'
      },
      {
        text: 'subtotal',
        value: 'net_total',
        format: 'currency'
      },
    ]
  }

  /**
   * The pch detail purchase order model
   */
  static model = PchDetailPurchaseOrderModel
}
